module.exports = __webpack_public_path__ + "img/26-min.7341f8f7.jpg";